import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const BrandsPage: React.FC = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Brands
      </Typography>
      <Card>
        <CardContent>
          <Typography>Brand management functionality coming soon...</Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BrandsPage; 